<template>
    <div class="traders-offer-confirm">
        <div v-if="traders" class="row mt-4 pt-4 border-top">
            <div class="col-12">
                <h4 class="text-dark"><i class="fa-regular fa-right-left"></i> You offered any one of these...</h4>
            </div>
            <!-- <div v-for="trader in traders.slice(0, 8)" :key="trader.id" class="col-3"> -->
            <div v-for="trader in traders" :key="trader.id" class="col-3 col-md-2 col-xl-1">
                <div class="card" data-bs-toggle="tooltip" data-bs-placement="top" :title="trader.title">
                    <picture>
                        <source :srcset="'https://pinandpop.s3.amazonaws.com/images/pinails/' + trader.image_pinail + '.webp'" type="image/webp">
                        <source :srcset="'https://pinandpop.s3.amazonaws.com/images/pinails/' + trader.image_pinail + '.jpg'" type="image/jpeg">
                        <img class="card-img-top border" :src="'https://pinandpop.s3.amazonaws.com/images/pinails/' + trader.image_pinail + '.jpg'" :alt="trader.title">
                    </picture>
                </div>
            </div>
            <!-- <div v-if="traders.length > 8" class="col-12 mt-2 text-center">
                <p class="and-more">&hellip; and {{ traders.length - 8 }} more</p>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'TradersOfferConfirm',
    props: {
        traders: {
            type: Array,
            required: true
        }
    }
}
</script>
